import { render } from "./Image.svg?vue&type=template&id=20bd4e58"
const script = {}
script.render = render

export default script